export const INITIAL_EDITOR_VALUE =
  '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}';

export const INITIAL_EDITOR_VALUE_LENGTH = 263;
